'use client';

import { useEffect, useState } from 'react';

export function useTypewriter(text: string, speed = 45, startDelay = 0, enabled = true) {
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDisplayed('');
    setDone(false);

    if (!enabled) return;

    if (!text) {
      setDone(true);
      return;
    }

    let i = 0;
    let tickTimer: ReturnType<typeof setTimeout> | undefined;

    const startTimer = setTimeout(() => {
      const tick = () => {
        i += 1;
        setDisplayed(text.slice(0, i));
        if (i >= text.length) {
          setDone(true);
          return;
        }
        tickTimer = setTimeout(tick, speed);
      };
      tick();
    }, startDelay);

    return () => {
      clearTimeout(startTimer);
      if (tickTimer) clearTimeout(tickTimer);
    };
  }, [text, speed, startDelay, enabled]);

  return { displayed, done };
}
